/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import type { Project } from '@jira/platform__project-types/src/project-types.tsx';
import { extractData } from '@atlassian/jira-navigation-apps-sidebar-utils/src/utils/extract-data/index.tsx';
import type { FetchResult } from '../../utils/throw-when-no-data-and-error/index.tsx';
import { useProjectSidebarNavigation } from '../common/project-sidebar-navigation-resource/index.tsx';
import type { QueueResourceCustomContext } from '../common/project-sidebar-navigation-resource/types.tsx';

export type UseProjectReturn = FetchResult<Project>;

export const useProject = (customContext?: QueueResourceCustomContext): UseProjectReturn => {
	const { data, loading, error } = useProjectSidebarNavigation(customContext);
	const project = useMemo(() => data && extractData(data), [data]);
	return { data: project, loading, error };
};
